import { Button, Col, Row, Typography, Empty, Tag, Image } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { DeleteOutlined } from "@ant-design/icons";
import { removeItem } from "../../../redux/slices/cartSlice";

const { Paragraph, Text } = Typography;
function Checkout() {
  const user = useSelector((state) => state.auth.value);
  const items = useSelector((v) => v.cart.value);
  const dispatch = useDispatch();
  let totalPrice = 0;
  items.forEach((item) => {
    totalPrice += item.price;
  });
  return (
    <div>
      <Row gutter={8}>
        <Col
          xs={24}
          sm={24}
          md={18}
          style={{ height: "70vh", overflowY: "auto" }}
        >
          <Paragraph strong style={{ fontSize: "16px" }}>
            Checkout items
          </Paragraph>
          {items.length < 1 ? (
            <Empty description="No Items selected!!!" />
          ) : (
            <>
              {" "}
              {items.map((item) => {
                return (
                  <div key={item.key} className="cart-item">
                    <Paragraph
                      style={{
                        borderBottom: "1px solid #ccc",
                        paddingBottom: "0.5rem",
                      }}
                    >
                      <Text style={{ fontSize: "14px", color: "#0c6f8d" }}>
                        {item.title}{" "}
                        <Tag color="cyan-inverse">{item.packageName} </Tag>
                      </Text>
                    </Paragraph>

                    <Row align="middle" gutter={12}>
                      <Col span={6}>
                        <Image
                          src={item.images[0]}
                          style={{ height: "100%" }}
                          preview={false}
                        />
                      </Col>
                      <Col span={18}>
                        <Paragraph
                          ellipsis={{
                            rows: 2,
                            expandable: true,
                            symbol: "more",
                          }}
                          style={{
                            fontSize: "12px",
                            color: "#888",
                            padding: "0.3rem 0",
                            margin: 0,
                          }}
                        >
                          {item.description}
                        </Paragraph>
                        <Row align="middle">
                          <Col span={12}>
                            <Paragraph
                              style={{
                                fontSize: "14px",
                                color: "#000",
                                margin: 0,
                              }}
                            >
                              Price:{" "}
                              <Text strong style={{ color: "#E83209" }}>
                                $ {item.price?.toLocaleString()}{" "}
                              </Text>
                            </Paragraph>
                          </Col>
                          <Col span={12} style={{ textAlign: "right" }}>
                            <Button
                              onClick={() =>
                                dispatch(removeItem({ key: item.key }))
                              }
                              icon={<DeleteOutlined />}
                              size="small"
                              type="primary"
                              danger
                            >
                              Remove
                            </Button>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </div>
                );
              })}
            </>
          )}
        </Col>
        <Col xs={24} sm={24} md={6}>
          <Paragraph strong style={{ fontSize: "16px" }}>
            Checkout Summary
          </Paragraph>
          <Paragraph>Total Items: 0{items.length}</Paragraph>
          <Paragraph>Total Price: $ {totalPrice?.toLocaleString()}</Paragraph>
        </Col>
      </Row>
    </div>
  );
}

export default Checkout;
